import React from 'react';
import { HuchaValues } from '../../../models/hucha-values';
import { HuchaBonusCardC1 } from './hucha-bonus-card-c1';
import { HuchaBonusCardC3 } from './hucha-bonus-card-c3';
import { HuchaBonusCardC2 } from './hucha-bonus-card-c2';
import { HuchaCardContainer } from '../../ui/hucha-card-container';

const HuchaBonusCard: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }): React.ReactElement => {
	return (
		<HuchaCardContainer>
			<HuchaBonusCardC1 />
			<HuchaBonusCardC2 />
			<HuchaBonusCardC3 huchaValues={huchaValues} />
		</HuchaCardContainer>
	);
};

export default HuchaBonusCard;
